
import { setDisplayErrorSnackBar} from "../../../../features/userSlice";
import { competitorsPageSpeedService } from "../../../../services/api/competitors-page-speed.endpoints";
import store from "../../../../store";


async function getPsiRequestsOfCompetitors(oauthTokenHeader: string,website_shared_uid:string|null, setIsLoading: any,setRows:any, trackPromise: any) {
    try {
        store.dispatch(setIsLoading(true));
        const response = await competitorsPageSpeedService.getPsiRequestsOfCompetitors(oauthTokenHeader,website_shared_uid);
        if (!response || !response.status || response.status !== 200) {
            throw new Error('Failed to get page content');
        }
        else {
            setRows(response?.data?.data); // Set the fetched data
        }
    } catch (e:any) {
        setRows([]);
        trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' })));
    }
}

async function putPsiRequestsOfCompetitors(oauthTokenHeader: string,website_shared_uid:string|null,psi_shared_uid:any,data:any,setStatus:any) {
    try {
        // store.dispatch(setIsLoading(true));
        const response = await competitorsPageSpeedService.putPsiRequestOfCompetitors(oauthTokenHeader,website_shared_uid,psi_shared_uid,data);
        if (!response || !response.status || response.status !== 200) {
            throw new Error('Failed to get page content');
        }
        else {
            setStatus(response?.data?.data); // Set the fetched data
        }
    } catch (e:any) {
        (store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' })));
    }
}

async function getSerpCompetitors(oauthTokenHeader: string,setData:any, trackPromise: any) {
    try {
        // store.dispatch(setIsLoading(true));
        const response = await competitorsPageSpeedService.getSerpCompetitors(oauthTokenHeader);
        if (!response || !response.status || response.status !== 200) {
            throw new Error('Failed to get page content');
        }
        else {
            setData(response?.data?.data); // Set the fetched data
        }
    } catch (e:any) {
        trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' })));
    }
}

async function postCompetitors(oauthTokenHeader: string,setData:any,website_shared_uid:any,data:any) {
    try {
        // store.dispatch(setIsLoading(true));
        const response = await competitorsPageSpeedService.postCompetitors(oauthTokenHeader,website_shared_uid,data);
        if (!response || !response.status || response.status !== 201) {
            throw new Error('Failed to get page content');
        }
        else {
            setData(response?.data?.data); // Set the fetched data
        }
    } catch (e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

async function postSerpCompetitor(oauthTokenHeader: string,data:any,setData:any) {
    try {
        // store.dispatch(setIsLoading(true));
        const response = await competitorsPageSpeedService.postSerpCompetitor(oauthTokenHeader,data);
        if (!response || !response.status || response.status !== 201) {
            throw new Error('Failed to create page content');
        }
        else {
            setData(response?.data?.data); // Set the fetched data
        }
    } catch (e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

async function getCompetitorsDashBoardExecuteQueries(oauthTokenHeader: string, setDashboardExecuteQueries: any, website_shared_uid: string, start_date: any, end_date: any, QUERY_ID: any, device:any,trackPromise:any) {
    try {
        const response = await competitorsPageSpeedService.getCompetitorsDashboadExecuteQuery(oauthTokenHeader, website_shared_uid, start_date, end_date, QUERY_ID, device);
        if (!response.status || response.status !== 200) {
            throw new Error();
        }
        else {
            setDashboardExecuteQueries(response?.data?.data);
        }
    } catch (e: any) {
        trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' })));
    }
}


// eslint-disable-next-line
export const PsiCompetitors = {
    getPsiRequestsOfCompetitors,
    putPsiRequestsOfCompetitors,
    getSerpCompetitors,
    postCompetitors,
    postSerpCompetitor,
    getCompetitorsDashBoardExecuteQueries
};
